import React, { useEffect, useState } from "react";
import SideMenu from "../Pages/SideMenu";
import Header from "../Pages/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Pages/Footer";
import Logout from "../Pages/Logout";
import { Button, Modal } from "react-bootstrap";
import { CustomTable } from "../CustomTable";
import { DripMasterAdd, DripMasterGet, FarmOperation_getMasters } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { CustomModal } from "../CustomModal";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import { modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";


export const DripSystemMaster = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [getLocation, setGetLocation] = useState([])
    const [dripName, setDripName] = useState()
    const [locationName, setLocationName] = useState()
    const [locationId, setLocationId] = useState()
    const [status, setStatus] = useState()
    const [id, setId] = useState()
    const [saveEdit, setSaveEdit] = useState()
    const [responseMsg, setResponseMsg] = useState()
    const [msgPopup, setMsgPopup] = useState(false)
    const [dripError, setDripError] = useState('')
    const [locationError, setLocationError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [loader, setLoader] = useState(false)

    const getDripSystemData = async () => {
        const URL = DripMasterGet;
        try {
            setLoader(true)
            // const response = await axios.get(URL)
            const headers = await GetApiHeaders();
            const response = await axios.get(URL, {
                headers,
            });

            setData(response.data.response)
            setLoader(false)
        } catch (error) {
            console.log(error)
        }
    }

    const LocationDropdown = async () => {
        const apiUrl = FarmOperation_getMasters;
        const headers = await GetApiHeaders();
        try {
            const response = await axios.get(apiUrl, { headers })
            setGetLocation(response.data.response.subSiteMaster)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getDripSystemData()
        LocationDropdown()
    }, [])

    const headersData = [
        {
            field: "name",
            header: "Drip System Id",
        },
        {
            field: "locationid.name",
            header: "Location Name",
        },
        {
            field: "createdBy.firstName",
            header: "Created By",
        },

        {
            field: "active",
            header: "Status",
        },
    ];

    const onEditClicked = (data) => {

        setSaveEdit('Update')
        setId(data.id)
        setShowModal(true)
        setDripName(data.name)
        setLocationName(data.locationid.name)
        setLocationId(data.locationid.id)
        setStatus(data.active)
        setDripError('')
        setLocationError('')
        setStatusError('')
    }

    const handleModalOpen = () => {
        setSaveEdit('Submit')
        setShowModal(true)
        setDripName('')
        setLocationName('')
        setStatus('')
        setLocationId('')
        setDripError('')
        setLocationError('')
        setStatusError('')
    }
    const handleCancel_new = () => {
        setShowModal(false)
    }

    const formatRoleName = (value) => {
        return value
            .replace(/[^a-zA-Z0-9]/g, '')
            .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    };

    const handleDripName = (e) => {
        const dripInput = e.target.value
        // const alphanumericInput = dripInput.replace(/[^a-zA-Z0-9]/g, '');
        const formattedDripName = formatRoleName(dripInput)
        setDripName(formattedDripName)
        if (dripInput) {
            setDripError('')
        }
    }



    const handleLocation = (e) => {
        const locationInput = e.target.value
        setLocationName(locationInput)
        const locationsID = e.target.options[e.target.selectedIndex].getAttribute("data-locationId");
        setLocationId(locationsID)
        if (locationInput) {
            setLocationError('')
        }
    }



    const handleStatus = (e) => {
        const statusInput = e.target.value;
        setStatus(statusInput);

        if (statusInput !== null && statusInput !== undefined && statusInput !== "") {
            setStatusError("");
        }
    };

    const handleSubmitData = async () => {
        const apiUrl = DripMasterAdd;
        const reqData = {
            id: saveEdit === "Submit" ? 0 : id,
            name: dripName,
            locationId: parseInt(locationId),
            locationName: locationName,
            status: status
        }
        const headers = await GetApiHeaders()
        try {
            if (!status) {
                setStatusError("Select Status")
            }
            if (!locationName) {
                setLocationError('Select Location')
            }
            if (!dripName) {
                setDripError('Enter Drip System Id')
            }
            if (dripName !== '' && locationName !== '' && status !== '') {
                setLoader(true)
                const response = await axios.post(apiUrl, reqData, { headers })
                if (response.data.statusCode == 200 || response.data.status == 500) {
                    setShowModal(false)
                    setMsgPopup(true)
                    setResponseMsg(response.data.message);
                    setLoader(false)
                }
            }

        } catch (error) {
            console.log(error)
        }
    }
    const handleOk = () => {
        setMsgPopup(false)
        getDripSystemData()
    }

    return (
        <body id="page-top">
            <div id="wrapper">
                <SideMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div>
                            <div className="container-fluid">
                                <div className="card border-0">
                                    <div className="card-body pt-0 pl-1">
                                        <h5 className="Roles_text">  Master</h5>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-0 Sub_role_text"> Drip System Master</h6>
                                            </div>
                                            <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Add Drip system Master"  >
                                                <Button variant="primary" className="buttons" onClick={handleModalOpen}  >
                                                    <FontAwesomeIcon icon={faPlus} className="plus_icon mr-1" />
                                                    Add
                                                </Button>
                                            </span>
                                        </div>
                                        <div className="mcrc_hrline"></div>
                                        <CustomTable
                                            headers={headersData}
                                            data={data}
                                            showAction={true}
                                            showButtons={true}
                                            ActionEdit={true}
                                            onEditClicked={onEditClicked}
                                            ActionName={"Action"}
                                            loader={loader}
                                            FileName={'Drip_System'}
                                        />

                                        <CustomModal
                                            showModal={showModal}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Drip System'}
                                            buttonText={saveEdit}
                                            handleSubmitData={handleSubmitData}
                                            childrens={
                                                <div>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12 mt-2'>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Drip System Id <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " placeholder='Enter Drip system Id' value={dripName} onChange={handleDripName} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {dripError}</span>
                                                        </div>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="InputName"
                                                                className="form-label text-sm font-weight-600 " style={{ marginTop: "13px" }}
                                                            >
                                                                Location <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="dropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Location Name"
                                                                value={
                                                                    getLocation
                                                                        .map((item) => ({
                                                                            value: item.name,
                                                                            label: item.name,
                                                                            locationId: item.code,
                                                                        }))
                                                                        .find((option) => option.value === locationName) || null
                                                                }
                                                                options={getLocation.map((item) => ({
                                                                    value: item.name,
                                                                    label: item.name,
                                                                    locationId: item.code,
                                                                }))}
                                                                onChange={(selectedOption) =>
                                                                    handleLocation({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                            options: [
                                                                                {
                                                                                    getAttribute: (attr) => {
                                                                                        if (attr === "data-locationId") {
                                                                                            return selectedOption?.locationId || "";
                                                                                        }
                                                                                        return "";
                                                                                    },
                                                                                },
                                                                            ],
                                                                            selectedIndex: 0,
                                                                        },
                                                                    })
                                                                }
                                                                isClearable
                                                            />

                                                            <span style={{ color: "red" }}>
                                                                {locationError}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='row'>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="InputName"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                Status <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="dropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Status"
                                                                value={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ].find(
                                                                    (option) => String(option.value) === String(status)
                                                                ) || null}
                                                                options={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ]}
                                                                onChange={(selectedOption) =>
                                                                    handleStatus({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                                isClearable
                                                            />
                                                        </div>
                                                        <span style={{ color: "red" }}> {statusError}</span>
                                                    </div>
                                                </div>
                                            }
                                        />
                                        <CustomModal
                                            showModal={msgPopup}
                                            msgPopup={msgPopup}
                                            handleOk={handleOk}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Drip System'}
                                            childrens={<div className="p-4 d-flex justify-content-center" style={{ fontSize: "18px", color: "#4A7729", fontWeight: 500 }}>{responseMsg}</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            <Logout />
        </body>
    )
}